import { render, staticRenderFns } from "./YouFace.vue?vue&type=template&id=1c38a538"
import script from "./YouFace.vue?vue&type=script&lang=js"
export * from "./YouFace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports